import { useEffect, useState } from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import usePermisos from '../../../hooks/usePermisos';
import axios from '../../../axios';
import Squares2X2Icon from '@heroicons/react/24/outline/Squares2X2Icon';
import { useNavigate, useParams } from 'react-router-dom';

const PERMISOS_REQUERIDOS = [
    'products_update',
    'products_read'
];

const Edit = () => {
    const navigate = useNavigate();
    const { grupoId } = useParams();
    const { permisos, loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);
    const [grupo, setGrupo] = useState({ name: '', description: '', active: true });
    const [validate, setValidate] = useState({ name: true });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log("permisos", permisos);
        if (!loadingPermisos && !tienePermiso('products_update')) {
            setLoading(false);
        } else if (grupoId) {
            axios.get(`/api/product-groups/${grupoId}`)
                .then(res => {
                    console.log("Grupo obtenido", res.data);
                    setGrupo(res.data);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    }, [grupoId, loadingPermisos]);

    const _updateGrupo = (e) => {
        e.preventDefault();
        if (grupo.name.trim() === '') {
            setValidate({ ...validate, name: false });
            return;
        }
        axios.put(`/api/product-groups/${grupoId}`, grupo)
            .then(() => {
                alert('Grupo actualizado exitosamente');
                navigate('/admin/categoriasweb');
            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.message) {
                    alert('Error: ' + err.response.data.message);
                }
            });
    };

    if (loading) {
        return <div className="p-5 text-center">Cargando...</div>;
    }
    if (!tienePermiso('products_update')) {
        return <div className="p-5 text-center">No tienes permiso para editar esta categoría web.</div>;
    }

    return (
        <>
            <div className='container-admin-menu'> <Breadcrumb /> </div>
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1'>
                    <h5 className="p-5 text-xl font-bold flex items-center justify-start"> <Squares2X2Icon className="inline-block h-6 w-6 mr-2" /> Editar Categoría Web</h5>
                    <form className='grid grid-cols-12 gap-4 px-5 pb-5' onSubmit={_updateGrupo}>
                        {/* Nombre */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="name" className="text-sm font-medium text-gray-600">Nombre de la Categoría*</label>
                                <input
                                    id="name"
                                    type="text"
                                    className="dento-input"
                                    value={grupo.name}
                                    onChange={e => setGrupo({ ...grupo, name: e.target.value })}
                                />
                                {!validate.name && (
                                    <span className="text-sm text-red-500">El nombre de la categoría es obligatorio.</span>
                                )}
                            </div>
                        </div>
                        {/* Descripción */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="description" className="text-sm font-medium text-gray-600">Descripción</label>
                                <textarea
                                    id="description"
                                    className="dento-input min-h-26"
                                    value={grupo.description || ''}
                                    onChange={e => setGrupo({ ...grupo, description: e.target.value })}
                                />
                            </div>
                        </div>
                        {/* Activo */}
                        <div className="col-span-12 flex items-center gap-2">
                            <input
                                id="active"
                                type="checkbox"
                                checked={!!grupo.active}
                                onChange={e => setGrupo({ ...grupo, active: e.target.checked })}
                            />
                            <label htmlFor="active" className="text-sm font-medium text-gray-600">Activo</label>
                        </div>
                        {/* Botón guardar  si tiene permiso */}
                        {tienePermiso('products_update') && (
                            <div className="col-span-12 pt-6 flex justify-end">
                                <button
                                    className="inline-flex items-center gap-2 px-6 py-2.5 bg-blue-600 text-white hover:bg-blue-700 font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 cursor-pointer"
                                    type="submit"
                                >
                                    Guardar cambios
                                    <span className="material-icons">save</span>
                                </button>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </>
    );
};

export default Edit;